module.exports = __webpack_public_path__ + "static/media/allergens_selected.6818f10c.svg";